import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
	newInfoTime: ''
}

const mutations = {
	praceNewInfoTime (state, params) {
		state.newInfoTime = params
	}
}

const actions = {
	getNewInfoTime (context, params) {
		context.commit('praceNewInfoTime', params)
	}
}

// 创建管理全局状态的对象
// store
const store = new Vuex.Store({
	// 配置全局状态
	state,
	mutations,
	actions
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js